import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { CustomerRecordModel } from '../../../models/customer-record.model';
import {
	CUSTOMER_TYPES,
	CUSTOMER_STATUSES,
} from '../../../translations/customers-select-items';

@Component({
	selector: 'app-customers-summary',
	templateUrl: 'customers-summary.component.html',
	imports: [
		FormsModule,
		ReactiveFormsModule,
		SectionWrapperComponent,
		SummaryItemComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
	],
})
export class CustomersSummaryComponent
	extends BaseSummarySectionComponent<CustomerRecordModel>
	implements OnInit
{
	public statuses = CUSTOMER_STATUSES;
	types = CUSTOMER_TYPES;

	protected _skipCount: number = 0;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<CustomerRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
